<script>
  import Input from '../../input-design/Input.svelte'
  import Editor from '../../input-design/Editor.svelte'
  import SocialNetwork from '../../social-network/SocialNetwork.svelte'
  import {
    projectDetailStore,
    initialProjectDetail,
  } from '../../../../stores/projectStore'

  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  let fields = initialProjectDetail()

  let errors = {
    projectTitle: '',
    briefDescription: '',
    coverImage: '',
    projectDescription: '',
  }
  let localImageFile

  const validateProjectDetailForm = () => {
    let valid = true

    if (!fields.projectTitle.trim()) {
      errors.projectTitle = 'Project Title is required'
      valid = false
    }

    if (!fields.briefDescription.trim()) {
      errors.briefDescription = 'Brief Description is required'
      valid = false
    }

    if (!fields.coverImage) {
      errors.coverImage = 'Cover Image is required'
      valid = false
    }

    if (!fields.projectDescription) {
      errors.projectDescription = 'Project Description is required'
      valid = false
    }

    if (!valid) return window.scroll({ top: 0 })

    errors = {
      projectTitle: '',
      briefDescription: '',
      coverImage: '',
      projectDescription: '',
    }
    projectDetailStore.setProjectDetail({ ...fields })
    dispatch('next')
    return true
  }

  const clearForm = () => {
    fields = initialProjectDetail()
    window.scroll({ top: 0 })
  }

  const setImageValues = (file) => {
    localImageFile = URL.createObjectURL(file)
    fields.coverImage = file
  }
</script>

<section>
  <form>
    <div class="flex flex-wrap form-row items-end">
      <div class="col-12">
        <Input
          bind:value={fields.projectTitle}
          on:input={() => (errors = { ...errors, projectTitle: '' })}
          error={errors.projectTitle}
          placeholder="Enter project title">
          <label slot="label" class="form-label">
            Project Title
            <small>*</small>
          </label>
          <span slot="label_dec" class="form-label-dec">
            Please enter the complete name of your project.
          </span>
        </Input>
        <div class="error">{errors.projectTitle}</div>
      </div>
      <div class="col-12">
        <Input
          bind:value={fields.briefDescription}
          on:input={() => (errors = { ...errors, briefDescription: '' })}
          error={errors.briefDescription}
          placeholder="Enter brief description">
          <label slot="label" class="form-label">
            Please enter a brief description of your project.
            <small>*</small>
          </label>
        </Input>
        <div class="error">{errors.briefDescription}</div>
      </div>
      <div class="col-12">
        <label class="form-label">
          Cover Image
          <small>*</small>
        </label>
        <label
          for="project-image"
          class="cursor-pointer relative flex justify-center items-center
          project-image-wrap">
          <input
            type="file"
            accept="image/*"
            class="absolute"
            id="project-image"
            on:input={() => (errors = { ...errors, coverImage: '' })}
            on:change={(e) => setImageValues(e.target.files[0])} />
          {#if localImageFile}
            <img
              src={localImageFile}
              class="project-image"
              alt="project image" />
          {/if}
          <span class="flex column-direction items-center">
            <img
              src="./images/file-upload.svg"
              class="m-auto"
              alt="upload image" />
            Click to add an asset or drag and drop one in this area
          </span>
        </label>
        <div class="error">{errors.coverImage}</div>
      </div>
      <div class="col-12">
        <label class="form-label">Social Media URL’s</label>
        <SocialNetwork mediaUrls={fields.mediaUrls} />
      </div>
      <div class="col-12">
        <label class="form-label">
          Project Description
          <small>*</small>
        </label>
        <Editor
          initialValue=""
          on:change={(event) => (fields.projectDescription = event.detail)} />
      </div>
    </div>
  </form>
</section>
<div class="pl-button-wrapper">
  <button class="pl-button pl-clear-btn" on:click={clearForm}>Clear</button>
  <button
    class="pl-button pl-next-btn"
    type="submit"
    on:click={validateProjectDetailForm}>
    Next
  </button>
</div>
